import { IPromise } from 'angular';
import * as moment from 'moment';

import * as Common from '../Common/modules';
import * as Models from '../Models';
import * as Services from '../Services';

export interface IUserService {
  getCurrentUser: () => ng.IPromise<any>;
  isUserInRole: (roleName: string) => ng.IPromise<any>;
}

export class UserService implements IUserService {
  public user: Models.UserModel.UserModel;
  public lastRefreshTime: Date;
  public requests: any[];
  public inflight: boolean;

  public static $inject = ["igs.identityService", "$q"];

  constructor(
    private identityService: Common.Identity.Igs.Common.IIdentityService,
    private $q: angular.IQService
  ) {
    this.inflight = false;
    this.requests = [];
  }

  public getCurrentUser = (): ng.IPromise<any> => {
    var deferred = this.$q.defer();

    // Check if we're on the login page - if so, skip the API call to prevent redirect loops
    const isLoginPage = window.location.hash.toLowerCase().includes('/login');
    if (isLoginPage) {
      deferred.reject();
      return deferred.promise;
    }

    if (!this.user || this.shouldRefreshUser()) {
      if (!this.inflight) {
        this.inflight = true;
        var that = this;
        this.identityService.getCurrentUser().then((data: Models.UserModel.UserModel) => {
          if (data) {
            that.user = data;
            that.lastRefreshTime = new Date();
            that.inflight = false;
            that.requests.forEach((x) => {
              x.resolve(that.user);
            });
            deferred.resolve(that.user);
          } else {
            that.inflight = false;

            if (window.location.href.indexOf('docusignRedirect') === -1 ) {
              that.identityService.goToLoginPage();
            }
            that.requests.forEach((x) => x.reject());
            deferred.reject();
          }
        });
      } else {
        this.requests.push(deferred);
      }
    } else {
      deferred.resolve(this.user);
    }
    return deferred.promise;
  };

  public isUserInRole = (role: string): ng.IPromise<any> => {
    var deferred = this.$q.defer();
    this.getCurrentUser().then(() => {
      deferred.resolve(this.user.roles.some((e) => e.name === role));
      return deferred.promise;
    });
    return deferred.promise;
  };

  private shouldRefreshUser = (): boolean => {
    var fortyFiveMinutesAgo = moment(new Date()).subtract(45, "minutes");
    var shouldRefreshUser = moment(this.lastRefreshTime).isBefore(fortyFiveMinutesAgo);
    if (shouldRefreshUser) {
      this.inflight = false;
      this.requests = [];
    }

    return shouldRefreshUser;
  };
}
